import { createContext, useContext } from 'react';

export const PanelAccessContext = createContext(null);

export function usePanelAccess() {
  return useContext(PanelAccessContext);
}

export function usePanelOwnerUserId(sessionUserId) {
  const access = usePanelAccess();
  if (!access) return sessionUserId ?? null;
  if (access.ownerUserId) return access.ownerUserId;
  return sessionUserId ?? null;
}
